var _path, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLangEn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 36,
    viewBox: "0 0 48 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.5 22.5a3 3 0 0 1-3 3H10.5l-6 6V7.5a3 3 0 0 1 3-3h33a3 3 0 0 1 3 3v15z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 24,
    y: 18,
    fontFamily: "OpenDyslexic, Arial, sans-serif",
    fontSize: 9,
    fill: "currentColor",
    textAnchor: "middle",
    dominantBaseline: "middle"
  }, "Hello!")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLangEn);
export default __webpack_public_path__ + "static/media/lang-en.df143300e7715a15cd89f0a94214bacf.svg";
export { ForwardRef as ReactComponent };